import { SelectListEvent } from '@acies/core';
import { ComponentCO2 } from '@acies/domain';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from '@shared/services/storage.service';
import { UserService } from '@shared/services/user.service';
import CO2Model from '../models/co2-model';
import CO2Service from '../services/co2-service';
import CreateComponentCO2Controller from './create-component-co2-controller';
import CreateComponentCO2LinkController from './create-component-co2link-controller';
import DeleteComponentCO2Controller from './delete-component-co2-controller';
import DeleteComponentCO2LinkController from './delete-component-co2link-controller';
import EditComponentCO2Controller from './edit-component-co2-controller';
import FilterComponentCO2Controller from './filter-component-co2-controller';
import FilterComponentCO2LinkController from './filter-component-co2link-controller';
import ImportCSVController from './import-csv-controller';
import ListComponentCO2Controller from './list-component-co2-controller';
import ListComponentCO2LinkController from './list-component-co2link-controller';
import PhasesCO2Controller from './phases-co2-controller';
import SearchCo2LinkController from './search-co2link.controller';

/** The CO2Controller is responsible for instantiation of the child controllers and hold a reference to them as public properties we can hook into from the view. */
export default class CO2Controller {
	public createComponentCO2Controller: CreateComponentCO2Controller;
	public editComponentCO2Controller: EditComponentCO2Controller;
	public filterComponentCO2Controller: FilterComponentCO2Controller;
	public listComponentCO2Controller: ListComponentCO2Controller;
	public phasesCO2Controller: PhasesCO2Controller;
	public deleteComponentCO2Controller: DeleteComponentCO2Controller;
	public createComponentCO2LinkController: CreateComponentCO2LinkController;
	public listComponentCO2LinkController: ListComponentCO2LinkController;
	public deleteComponentCO2LinkController: DeleteComponentCO2LinkController;
	public filterComponentCO2LinkController: FilterComponentCO2LinkController;
	public importCSVController: ImportCSVController;
	public searchCO2LinkController: SearchCo2LinkController;
	public constructor(co2Model: CO2Model, co2Service: CO2Service, userService: UserService, translateService: TranslateService, sessionStorageService: SessionStorageService) {
		this.createComponentCO2Controller = new CreateComponentCO2Controller(co2Model, co2Service);
		this.filterComponentCO2Controller = new FilterComponentCO2Controller(co2Model);
		this.editComponentCO2Controller = new EditComponentCO2Controller(co2Model, co2Service);
		this.listComponentCO2LinkController = new ListComponentCO2LinkController(co2Model, co2Service);
		this.listComponentCO2Controller = new ListComponentCO2Controller(co2Model, co2Service, userService, sessionStorageService, () => this.listComponentCO2LinkController.clearSelection());
		this.phasesCO2Controller = new PhasesCO2Controller(co2Model);
		this.deleteComponentCO2Controller = new DeleteComponentCO2Controller(co2Model, co2Service);
		this.createComponentCO2LinkController = new CreateComponentCO2LinkController(co2Model, co2Service);
		this.deleteComponentCO2LinkController = new DeleteComponentCO2LinkController(co2Model, co2Service);
		this.filterComponentCO2LinkController = new FilterComponentCO2LinkController(co2Model);
		this.importCSVController = new ImportCSVController(co2Model, co2Service);
		this.searchCO2LinkController = new SearchCo2LinkController(co2Model, co2Service, translateService);
	}

	/** We pass down the SelectListEvent to the controllers that need it, since we can not have more than one event handler in the UI. */
	public selectedComponentCO2Changed(event: Event): void {
		if (event instanceof SelectListEvent) {
			if (event.selectedItem instanceof ComponentCO2 || event.selectedItem === null) {
				this.phasesCO2Controller.selectedComponentCO2 = event.selectedItem;
				this.editComponentCO2Controller.selectedComponentCO2 = event.selectedItem;
				this.createComponentCO2LinkController.selectedComponentCO2 = event.selectedItem;
				this.listComponentCO2LinkController.selectedComponentCO2 = event.selectedItem;
				this.importCSVController.selectedComponentCO2 = event.selectedItem;
			}
		}
	}

	public destroy(): void {
		this.listComponentCO2Controller.destroy();
		this.listComponentCO2LinkController.destroy();
	}
}
